<template>
  <div class="container-fluid">
    <page-header
      :page="page"      
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <action-button          
          variant="success m-1"
          i="fas fa-file-plus pr-1"
          :responsive="false"
          @click="add"
        >
          Añadir
        </action-button>
      </template>
    </page-header>
     <filter-manager
      v-model="this.filters"
      :display-advanced="false"
      :filters="filtersHeader"   
      @search="handleSearch"
    />
    <CustomSeparator
      text="Resultado de Fortalezas y Necesidades"
      class="mt-4 custom-separator-line"
    />
    <CustomResultNotFound
      v-if="results.length == 0"
      class="mt-4"
      :text="noResultsText"
    />    

    <div class="row pt-2">
      <div v-if="results.length > 0" class="col-12">
        <ResultRow
          v-for="(item, index) in results"
          :key="`row-item-${index}`"
          :item="item"
          @on-save-inactivation="handleInactivation"
        />
      </div>
    </div>

    <div class="row pt-2">
      <div class="col-12 pt-0">
        <pagination
          v-if="pagination.totalItemCount > pagination.perPage"
          :data="pagination"
          @pagination-go-page="handlePagedChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import ActionButton from 'ActionButton';
import FilterManager from 'FilterManager';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from "pagination";
import ResultRow from "./components/ResultRow";
import { initFilters, search, inactive } from '@/services/operations/strengthsneeds'
import mixAlert from "@/mixin/alert.mixin";

export default {
  name: 'Main',
   mixins: [mixAlert],
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    ActionButton,
    CustomResultNotFound,
    Pagination,
    ResultRow
  },
  data() {
    return {
      page: {
        icon: 'fas fa-calculator',
        title: 'Manejo de Catálogo de Fortalezas y Necesidades',
        routes: ['Inicio', 'Operaciones', 'Manejo de Catálogo de Fortalezas y Necesidades'],
      },
      collections: {
        areas: [],
        grades: [],
        years: [],
      },
      filters: {
        area: null,
        grade: null,
        year: null,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      noResultsText: 'No se han encontrado resultados',
      results: []
    };
  },
  computed: {
    filtersHeader() {
      return [
        {
          name: 'year',
          component: 'CustomDropDown',
          options: this.collections.years,
          value: this.filters.year,
          placeholder: 'Año Académico',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4 ml-0 mr-0',
          classContainer: 'w-100',          
        },  
        {
          name: 'area',
          component: 'CustomDropDown',
          options: this.collections.areas,
          value: this.filters.area,
          placeholder: 'Área',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4 ml-0 mr-0',
          classContainer: 'w-100',          
        },
        {
          name: 'grade',
          component: 'CustomDropDown',
          options: this.collections.grades,
          value: this.filters.grade,
          placeholder: 'Grado',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4 ml-0 mr-0',
          classContainer: 'w-100',          
        },
      ]     
    }
  },
  async mounted(){
    await this.loadInitFilters()
  },
  methods: {
    async loadInitFilters(){
      const { data } = await initFilters();
      this.collections = data;
    },
    async handleSearch()
    {
      this.pagination.currentPage = 1
      await this.search();
    },
    async search() {      
      const payload = { 
        areaId: this.filters.area?.id,
        gradeId: this.filters.grade?.id,
        yearId: this.filters.year?.id,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.perPage                
      }

      try{
        const res = await search(payload)
      
        this.results = res.data.data;       
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };        
      }      
      catch(err) 
      {
          this.ShowToast(err.message, "", "error");
      };
    },
    handlePagedChanged(currentPage) {
      this.pagination.currentPage = currentPage
      this.search();
    },   
    add(){
      this.$router.push({name: 'addStrengthsNeedsManagement'})
    },
    async handleInactivation(payload){
      
      await inactive(payload)

      this.ShowToast("Proceso exitoso", "La Información ha sido guardada exitosamente.", "success");

      await this.search();
    }
  },
 
};
</script>
<style scoped>
</style>
